<div class="login-container" id="div_login-container_44ab17d4">
  <div class="left-pnl" id="div_left-pnl_93d314e8">
    <div [ngSwitch]="currentStep" id="div_3fe59936">
      <div *ngSwitchCase="login_enums.EMAIL" id="div_e0996cbf">
        <app-email
          (currentEmail)="setEmail($event)"
          (nextStep)="setStep($event)"
          (userLocked)="setUserLocked($event)"
          [email]="email"
        ></app-email>
      </div>
      <div *ngSwitchCase="login_enums.PASSWORD" id="div_185e32ee">
        <app-password
          [email]="email"
          (nextStep)="setStep($event)"
          [userLocked]="userLocked"
        ></app-password>
      </div>
      <div *ngSwitchCase="login_enums.SIGN_UP_SCREEN" id="div_7c15eb52">
        <app-sign-up
          (nextStep)="setStep($event)"
          [email]="email"
          [applicationType]="applicationType"
        ></app-sign-up>
      </div>
      <div *ngSwitchCase="login_enums.SIGN_UP_SCREEN_SUCCESS" id="div_6e9d4173">
        <app-sign-up-success></app-sign-up-success>
      </div>
      <div *ngSwitchCase="login_enums.FORGOT_PASSWORD_EMAIL" id="div_c67c3895">
        <app-forgot-password-email
          (nextStep)="setStep($event)"
          (forgotPasswordEmail)="setForgotPasswordEmail($event)"
        ></app-forgot-password-email>
      </div>
      <div *ngSwitchCase="login_enums.CHANGE_PASSWORD" id="div_32bed185">
        <app-change-password
          (nextStep)="setStep($event)"
          [email]="forgotPasswordEmail"
        ></app-change-password>
      </div>
      <div
        *ngSwitchCase="login_enums.ACCOUNT_CONFIRMED_SCREEN"
        id="div_788f04bd"
      >
        <app-account-confirmed
          (nextStep)="setStep($event)"
        ></app-account-confirmed>
      </div>
      <div *ngSwitchCase="login_enums.EMAIL_SENT_SCREEN" id="div_2eabfbae">
        <app-email-sent [email]="email"></app-email-sent>
      </div>
      <div *ngSwitchCase="login_enums.PASSWORD_CREATION" id="div_459a1db6">
        <app-create-password [email]="registrationEmail"></app-create-password>
      </div>
      <div *ngSwitchCase="login_enums.LINK_EXPIRED" id="div_1f4008b3">
        <app-link-expired></app-link-expired>
      </div>
      <div *ngSwitchCase="login_enums.ACCESS_DENIED" id="div_7b75f04a">
        <app-access-denied></app-access-denied>
      </div>
    </div>
  </div>
  <div class="right-pnl" id="div_right-pnl_9624d9f6">
    <img
      aria-label="login"
      title="login"
      src="../../../assets/images/login-bg.webp"
      alt="login"
      width="100%"
      height="580px"
      id="img_c7a06ab5"
    />
    <h1 aria-label="Railcar Search" title="Railcar Search" id="h1_0ad5c628">
      DELIVERING GOODS FOR THE <br />GOOD OF ALL™
    </h1>
    <div class="bottom-pnl" id="div_bottom-pnl_3fd6face">
      <a
        title="TRM link logo"
        target="_blank"
        href="https://trinityrail.com"
        class="trinity-logo"
        aria-label="TrinityRail website, opens in a new window"
        id="a_trinity-logo_a55e0749"
      >
        <img
          aria-label="trinity rail logo"
          title="trinity rail logo"
          width="139"
          height="33"
          src="../../../../assets/logos/rsi_logo.png"
          alt="trinity rail logo"
          id="img_9b9af384"
        />
      </a>
      <div id="div_ac911f41">
        <a
          href="https://legal.trin.net/Home/Privacy"
          target="_blank"
          style="margin-right: 17px"
          title="Privacy Policy"
          aria-label="Privacy Policy, opens in a new window"
          id="a_5eb3ff6d"
        >
          Privacy Policy
        </a>
        <a
          aria-label="Terms & Conditions"
          title="Terms & Conditions"
          href="https://legal.trin.net/"
          target="_blank"
          id="a_bca8a5cf"
          >Terms & Conditions</a
        >
      </div>
    </div>
  </div>
</div>
